import { StatusBadge } from '@src/common/components/StatusBadge';
import { orderStatusColors } from '@src/orders/components/OrderStatusColors';
import { OrderStatus } from '@src/orders/domain/Order';
import { useTranslation } from 'react-i18next';

interface Props {
  status: OrderStatus;
}

export const OrderStatusBadge = ({ status }: Props) => {
  const { t } = useTranslation();
  const statusValue = [
    OrderStatus.INVOICED,
    OrderStatus.MODIFY_INVOICE,
  ].includes(status)
    ? OrderStatus.TO_INVOICE
    : status;

  return (
    <StatusBadge
      size="small"
      text={t(statusValue.toLowerCase())}
      color={orderStatusColors[status].color}
      borderColor={orderStatusColors[status].border}
      backgroundColor={orderStatusColors[status].background}
    />
  );
};
